<template>
  <div>
    <section>
      <xlsx-workbook>
        <xlsx-sheet
          :collection="sheet.data"
          v-for="sheet in sheets"
          :key="sheet.name"
          :sheet-name="sheet.name"
        />
        <xlsx-download v-model="filename">
          <vs-button
            class="m-2"
            size="medium"
            type="border"
            icon-pack="feather"
            icon="icon-file-text"
            >Dışa Aktar</vs-button
          >
        </xlsx-download>
      </xlsx-workbook>
    </section>
  </div>
</template>

<script>
import XlsxRead from "./components/XlsxRead.vue";
import XlsxTable from "./components/XlsxTable.vue";
import XlsxSheets from "./components/XlsxSheets.vue";
import XlsxJson from "./components/XlsxJson.vue";
import XlsxWorkbook from "./components/XlsxWorkbook.vue";
import XlsxSheet from "./components/XlsxSheet.vue";
import XlsxDownload from "./components/XlsxDownload.vue";

export default {
  props: {
    printOnExcel: {
      type: Object,
      required: true,
    },
  },
  components: {
    XlsxRead,
    XlsxTable,
    XlsxSheets,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    return {
      dataForPrint: false,
      file: null,
      selectedSheet: null,
      sheetName: null,
      collection: [{ a: 1, b: 2 }],
    };
  },

  computed: {
    sheets() {
      return [
        {
          name: "NitroMekatronik",
          data: this.excelBeautifier(this.printOnExcel.table),
        },
      ];
    },
    filename() {
      return { filename: this.printOnExcel.filename };
    },
  },

  created() {
  },

  methods: {
    //personelReport.vue
    //inventoryReport.vue
    excelBeautifier(d) {
      let modificatedData = d;
      if (Array.isArray(modificatedData)) {
        for (let i = 0; i < modificatedData.length; i++) {
          let mKeys = Object.keys(modificatedData[i]);
          for (let j = 0; j < mKeys.length; j++) {
            let string = "";
            if (Array.isArray(modificatedData[i][mKeys[j]])) {
              if (modificatedData[i][mKeys[j]].length > 1) {
                for (let k = 0; k < modificatedData[i][mKeys[j]].length; k++) {
                  string +=
                    JSON.stringify(modificatedData[i][mKeys[j]][k]) + "\n";
                }
              } else {
                string = JSON.stringify(modificatedData[i][mKeys[j]]);
              }
              modificatedData[i][mKeys[j]] = string;
            }
          }
        }
        return modificatedData;
      }
      return { filename: "", table: [] };
    },

    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
    },
    addSheet() {
      this.sheets.push({ name: this.sheetName, data: [...this.collection] });
      this.sheetName = null;
    },
  },
};
</script>